<template>
<div class="search-page">
  <van-nav-bar style="opacity: 0;" :border="false" @click-left="back" placeholder title="搜索">
    <template #left>
      <van-icon size="20px" name="arrow-left" color="#fff" />
    </template>
  </van-nav-bar>
  <div class="search">
    <div class="input">
      <img class="icon" src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/search_icon.png" alt="" />
      <van-field @keyup.enter="onConfirm" class="uni-input-input" v-model="keywords" placeholder="搜索您感兴趣的内容" />
    </div>
    <div class="cancel" @click="back">取消</div>
  </div>
  <div class="index-tab-header" id="tab" v-if="type && category.length">
    <van-tabs color="#A40001" v-model="type" :ellipsis="false" @change="onConfirm">
      <van-tab :title="item.name" v-for="item of category" :key="item.id" :name="item.id"></van-tab>
    </van-tabs>
  </div>
  <div class="search-content" v-loading="listLoading" v-if="type!=='idea'">
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="loadmore" class="content" v-if="list.length">
      <PriceCard v-for="item of list" :key="item.id" :type="type" :cardData="item" @click.native="goDetail(item)"></PriceCard>
    </van-list>
    <div class="content nodata" style="height: calc(100vh - 196px)" v-else>
      <img src="https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/nodata.png" alt="" />
      <p>暂无相关内容~</p>
      <p></p>
    </div>
  </div>
  <idea-list :list="list" v-else></idea-list>
</div>
</template>

<script>
import PriceCard from "@/components/PriceCard";
import ideaList from '@/components/ideaList.vue';
export default {
  components: {
    PriceCard,
    ideaList,
  },
  computed: {
    partalName() {
      return this.$store.state.partal.name;
    },
     plat() {
      return this.$store.state.plat_id;
    },
  },
  data() {
    return {
      category: [
        {
          id: "live",
          name: "直播",
        },
        // {
        //   id: "idea",
        //   name: "锦囊",
        // },
      ],
      type:'',
      listLoading: false,
      page: 1,
      list: [],
      limit: 10,
      loading: false,
      finished: false,
      keywords: "",
    };
  },
  mounted(){
    if (this.$store.state.plat_id == '107' || this.$store.state.plat_id == '121') {
      this.category.unshift({
        id: "lesson",
        name: "VIP课程",
      })
    } else{
      this.category.unshift({
        id: "lesson",
        name: "基础课程",
      })
    }
    if(this.$store.state.plat_id == '120'){
      this.category=[]
      this.type = 'lesson'
    }else{
      this.type = this.category[0].id
    }
      // if (this.plat == 118 || this.plat == 119) {
      //   this.category.push({
      //     id: "train",
      //     name: "培训",
      //   });
      //   this.type = 'lesson'

      // }
      
  },
  methods: {
    goDetail(item) {
      if(this.type=='live'){
        let {
        name,
        video_url,
        host,
        img_url,
        category_name,
        video_id,
        ccid,
        cover,
        id
        } = item;
        let videoId = video_id;
        let type = 'aliyun'
        if (ccid) {
          id = ccid;
          type = 'cc';
        }
        if (video_url) {
          this.$router.push(`./LiveDetail?id=${id}&name=${name}&url=${video_url}&host=${host}&cover=${img_url}&category_name=${category_name}`);
        } else if(videoId){
          this.$router.push(`./LiveDetail?id=${id}&name=${name}&videoId=${videoId}&type=${type}&cover=${cover}`);

        }else{
          this.$toast('没有视频')
        }
      }else{
        this.$router.push(`./detail?id=${item.id}`)

      }
   
      
    },
    back() {
      this.keywords = '';
      this.$router.go(-1);
    },
 
    async onConfirm() {
      if(!this.keywords) return
      console.log('search')
      if(this.type=='idea'){
        let res = await this.$api({
                url: "/api/silkbag/search",
                data: {
                  keywords: this.keywords,
                },
              });
      
        if (res.code == 0) {
          res.data.forEach(item=>{
            item.updated_at = item.updated_at ? item.updated_at.slice(0,10) : ''
            item.content = item.content ? item.content.replace(/<\/?[^>]*>/g, "") : ''
            item.content = item.content.length>100 ? item.content.slice(0,100)+'...' : item.content
          })
          this.list = res.data
        } else {
          this.$toast(res.msg)
        }
      }else if(this.type=='live'){
        this.page = 1;
        this.listLoading = true;
        let res = await this.$api({
          method: "get",
          url: "/api/livestream/search",
          data: {
            keywords: this.keywords,
            page: this.page,
            limit: this.limit,
          },
        });
        if (res.code == 0) {
          this.listLoading = false;
          let target = res.data.filter((e) => {
            console.log(e.flat_id, this.plat);
            return e.flat_id == this.plat;
          })[0];
          console.log(target);
          if (target.res) {
            this.list = target.res;
          }else{
            this.list = []
          }
          this.loading = false;
          if (this.list.length < this.limit) {
            this.finished = true;
          }
        } else {
          this.$toast(res.msg);
        }

      }else{
        this.page = 1;
              this.listLoading = true;
              let res = await this.$api({
                url: "/api/users/university/changeList",
                data: {
                  type: this.type=='lesson' ? 2 : 1,
                  keywords: this.keywords,
                  page: this.page,
                  limit: this.limit,
                  is_interior: 2,
                  flat_id: this.plat,
                },
              });
        this.listLoading = false;
        if (res.code == 0) {
          this.list = res.data.list;
          this.loading = false;
          if (res.data.list.length < this.limit) {
            this.finished = true;
          }
        }
      }
      
    },
    async loadmore() {
      console.log("loadmore");
      if (this.finished) {
        return;
      }
      this.page += 1;
      let res = await this.$api({
        url: "/api/users/university/changeList",
        data: {
          keywords: this.keywords,
          page: this.page,
          limit: this.limit,
        },
      });
      if (res.code == 0) {
        this.list = this.list.concat(res.data.list);
        this.loading = false;
        if (res.data.list.length < this.limit) {
          this.finished = true;
        }
        console.log(
          res.data.list.length,
          this.limit,
          this.list.length,
          this.loading,
          this.finished
        );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.search-page {
  min-height: 100vh;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: column;
  .search {
    width: 100vw;
    height: 96px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #fff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    padding: 0 0 0 30px;
    box-sizing: border-box;
  }

  .icon {
    width: 31px;
    height: 31px;
    margin: 0 20px;
    flex: 0 0 31px;
  }

  .input {
    height: 66px;
    border-radius: 33px;
    width: 690px;
    background: #f0f2f8;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 0 1 auto;
  }

  .uni-input-input {
    position: relative;
    display: block;
    height: 100%;
    background: none;
    border: none;
    padding: 0;
    display: flex;
    align-items: center;
  }

  .cancel {
    width: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666;
    font-size: 30px;
  }

  .input input {
    width: 100%;
    height: 66px;
    font-size: 28px;
    font-weight: 400;
    color: #333;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex: 0 1 auto;
  }

  .input-placeholder {
    font-size: 28px;
    font-weight: 400;
    color: #9fa2b3;
  }



  .search-content {
    height: calc(100vh - 96px);
    overflow-y: auto;
  }

  .content {
    width: 100%;
    padding: 30px 0 0;
    box-sizing: border-box;
  }
}
</style>
